<template>
  <v-container fill-height grid-list-xs class="my-3">
    <v-layout row wrap justify-center align-center class="mb-5">
      <div class="animated fadeInUp text-xs-center">
        <h1 class="mb-2 font-weight-bold" :class="{'display-2': $vuetify.breakpoint.smAndDown, 'display-3': $vuetify.breakpoint.mdAndUp}">Hmmm... This isn't right.</h1>
        <div class="subheading mb-3 text-xs-center">If we knew you were coming we'd have made a page, but this is a 404.</div>
        <v-btn href="/" color="primary">Go Back</v-btn>
      </div>
    </v-layout>
  </v-container>
  
</template>

<script>
import { TimelineLite } from 'gsap'

export default { 

} 
</script>

<style>

</style>